import moment from 'moment';
// import React from 'react';
// const notAvailable = 'not-looking-for-job';
import { AVAILABILITY_STATUS_NAMES } from '../../constants/AvailabilityType';

export const getAvailabilityState = (data) => {
  const { availability, availableObj, notAvailableObj } = data;
  // let availabilityIcon;
  // let availabilityText;
  // const showStatus = false;
  let dateDiff;
  // let lastUpdate;

  if (!availability || !availableObj || !notAvailableObj) {
    console.error('Must have availability, availableObj and notAvailableObj');
    return {};
  }

  if (availability.last_update) {
    dateDiff = moment(moment(availability.last_update).add(30, 'days')).diff(moment(), 'days');
  }

  if (availability.value === AVAILABILITY_STATUS_NAMES.NOT_LOOKING_FOR_JOB || availability.value === AVAILABILITY_STATUS_NAMES.UNKNOWN || dateDiff <= 0) {
    return {
      availabilityIcon: notAvailableObj.icon,
      availabilityText: notAvailableObj.iconText || notAvailableObj.label,
      showStatus: false,
      lastUpdate: null,
      dateDiff
    };
  }

  return {
    availabilityIcon: dateDiff < 15 ? (availableObj.replacementIcon || availableObj.icon) : availableObj.icon,
    availabilityText: availableObj.iconText || availableObj.label,
    showStatus: true,
    lastUpdate: dateDiff < 15 ? dateDiff : null,
    dateDiff
  };

  /* BYPASS THE CODE BELOW
  if (availability && availability.icon && availability.label) {
    /** if  date difference is negative, then show the unavailable info
    if (dateDiff <= 0 && notAvailableObj.length > 0) {
      availabilityIcon = notAvailableObj[0].icon;
      availabilityText = notAvailableObj[0].iconText || notAvailableObj[0].label;
      lastUpdate = moment().to(moment(availability.last_update));
    } else {
      availabilityIcon = availability.icon;
      availabilityText = availability.iconText || availability.label;
      if ((availability.value !== notAvailable)) {
        showStatus = true;
        availabilityIcon = availableObj[0].icon;
        availabilityText = availableObj[0].iconText || availableObj[0].label;
        /** Show warning text if the date diff is less than 15
        if ((dateDiff || dateDiff === 0) && dateDiff < 15) {
          // Use a replacement icon if available
          if (availableObj[0].replacementIcon) availabilityIcon = availableObj[0].replacementIcon;
          lastUpdate = dateDiff;
        }
      }
    }
  } else {
    availabilityIcon = availability.icon;
    availabilityText = availability.iconText || availability.label;
    if ((availability.value !== notAvailable)) {
      showStatus = true;
      availabilityIcon = availableObj[0].icon;
      availabilityText = availableObj[0].iconText || availableObj[0].label;
      /** Show warning text if the date diff is less than 15
      if ((dateDiff || dateDiff === 0) && dateDiff < 15) {
        // Use a replacement icon if available
        if (availableObj[0].replacementIcon) availabilityIcon = availableObj[0].replacementIcon;
        // warningText = isNavigation ? warningText = <span className="expires-warning">Expires in {dateDiff} {dateDiff > 1 ? 'days' : 'day'} <span style={{ color: '#2E6EDF' }}>Update Now</span></span> : <span className="availability-description">Expires in <span style={{ color: '#FF784E' }}>{dateDiff} {dateDiff > 1 ? 'days' : 'day'}</span></span>;
      }
    }
  }

  return { availabilityIcon, availabilityText, showStatus, lastUpdate, dateDiff }; */
};
